import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import InventoryForm from '../../../components/forms/InventoryForm'
import Popup from '../../../components/elements/Popup'

import Types from '../../../actions/Types'
import PutAction from '../../../actions/inventories/PutAction'
import ListLocationsAction from '../../../actions/locations/ListLinearAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class UpdateInventoryPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      submit: null
    }

    // Bind events
    this.submit = this.submit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    this.props.fetchLocations()
  }

  componentDidUpdate(prevProps, prevState) {
    // If fetch is error, close with error
    if (
      prevProps.isLoading
      &&
      !this.props.isLoading
      &&
      this.props.loadError
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.FAILURE, "Impossible d'obtenir les infos sur cet inventaire.")
      this.props.onClose(false)
    }

    // When successful, close popup
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.saveError
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Inventaire modifié.')
      this.props.onClose(true)
    }
  }

  submit() {
    if (_.isFunction(this.state.submit)) {
      this.state.submit()
    }
  }

  onSubmit(data) {
    this.props.put(this.props.id, data)
  }

  render() {
    return (
      <Popup
        header="Modifier l'inventaire"
        body={
          <InventoryForm
            data={this.props.data}
            location={undefined}
            onSubmit={this.onSubmit}
            onClearError={this.props.clearError}
            isLoading={this.props.isLoading}
            isSaving={this.props.isSaving}
            registerSubmit={(submit) => { this.setState({ submit })}}
            error={this.props.saveError}
            locationsList={this.props.locationsList}
            locationsIsFetching={this.props.locationsIsFetching}
          />
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Annuler',
            color: 'red',
            icon: 'close',
            basic: true,
            onClick: () => this.props.onClose(false)
          },
          {
            type: Popup.BUTTONTYPE.SUBMIT,
            title: 'Modifier',
            color: 'orange',
            icon: 'checkmark',
            onClick: this.submit
          }
        ]}
        isLoading={this.props.isLoading}
        isSaving={this.props.isSaving}
      />
    )
  }
}

UpdateInventoryPopup.propTypes = {
  // Properties
  id: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,

  // Redux State
  data: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  loadError: PropTypes.object,
  isSaving: PropTypes.bool.isRequired,
  saveError: PropTypes.object,
  locationsList: PropTypes.array,
  locationsIsFetching: PropTypes.bool.isRequired,

  // Redux Actions
  put: PropTypes.func.isRequired,
  fetchLocations: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    data: state.entities.inventories.get.data,
    isLoading: state.entities.inventories.get.isFetching,
    loadError: state.entities.inventories.get.error,
    isSaving: state.entities.inventories.put.isFetching,
    saveError: state.entities.inventories.put.error,
    locationsList: state.entities.locations.list.linear.data,
    locationsIsFetching: state.entities.locations.list.linear.isFetching
  }),
  (dispatch) => ({
    put: (id, data) => (dispatch(PutAction({ id, data }))),
    fetchLocations: () => (dispatch(ListLocationsAction({}))),
    clearError: () => (dispatch(ClearErrorAction(Types.INVENTORIES.PUT)))
  })
)(UpdateInventoryPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/inventories/UpdateInventoryPopup.js